import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="faq-suggestions"
// Stubbed FAQ suggestion chips (Phase 1, no AI): a chip fires the SAME cocoon
// insertion as the "Add Question" link and prefills the question (answer only
// for the print-ticket chip). Inserted FAQs are ordinary cocoon cards —
// editing / drag-sort / remove all behave as usual. A chip hides once its
// question exists; when every chip is used the row collapses (hint stays).
export default class extends Controller {
  static targets = ["row", "chip", "addLink"]

  connect() {
    this.syncUsed()
  }

  add(event) {
    const chip = event.currentTarget
    // Cocoon inserts synchronously on click, appending to #faqs-container.
    this.addLinkTarget.click()
    const card = this.element.querySelector("#faqs-container").lastElementChild
    if (!card) return
    card.querySelector("input[name*='[question]']").value = chip.dataset.question
    if (chip.dataset.answer) {
      card.querySelector("textarea[name*='[answer]']").value = chip.dataset.answer
    }
    chip.hidden = true
    this.collapseIfAllUsed()
    card.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  // On load, hide chips whose question exactly matches an existing FAQ.
  syncUsed() {
    const existing = [...this.element.querySelectorAll("#faqs-container input[name*='[question]']")]
      .map((i) => i.value.trim())
    this.chipTargets.forEach((chip) => {
      if (existing.includes(chip.dataset.question)) chip.hidden = true
    })
    this.collapseIfAllUsed()
  }

  collapseIfAllUsed() {
    this.rowTarget.hidden = this.chipTargets.every((chip) => chip.hidden)
  }
}
